<div class="workspace no-back-btn">
  <div class="row">
    <div class="col-xl-9 col-md-8 col-sm-12 d-flex dashboard-left-container">
      <div class="dashboard-left flex-fill">
        <div class="d-none d-md-block col-md-12 dashboard-breadcumb">
          <div class="d-flex flex-row">
            <div class="d-flex breadcumb-container">
              <div class="row flex-g1">
                <div class="col-md-12 col-sm-12 breadcumb-header">
                  <div class="d-flex flex-row flex-wrap">
                    <div class="d-flex flex-row align-items-center">
                      <a class="not-underline first-line text-semi-bold-font">{{"dashboard.breadcumb_root" | translate}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 dashboard-kpis">
          <div class="d-sm-block d-md-none title">{{'dashboard.quick_statistics' | translate}}</div>
          <div class="no-bg" *ngIf="dashboardKPIData">
            <kpi-report [kpi]="dashboardKPIData" [showKpiStatus]="true">
            </kpi-report>
          </div>
        </div>
        <div class="d-none d-md-block col-md-12 col-sm-12 dashboard-post-container">
          <achoo-infinite-scroll
            [scrollDistance]="scrollDistance"
            [infiniteScrollThrottle]="throttle"
            (scrollDownEvent)="onScrollDown()"
          >
            <div class="d-flex flex-row flex-nowrap">
              <div class="d-flex flex-row flex-auto align-items-center full-width">
                <div class="full-width">
                  <div class="dashboard-filter">
                    <ng-select
                      class="dashboard-filter-dropdown"
                      [items]="socialFilterOptions"
                      bindLabel="name"
                      bindValue="value"
                      [searchable]="false"
                      [clearable]="false"
                      (change)="onChangeChannel($event)"
                      placeholder="{{ 'dashboard.social_channel' | translate }}"
                      [(ngModel)]="currentSocialFilter"
                    >
                    </ng-select>
                  </div>
                  <div class="col-md-12 col-sm-12" id="post_list_container">
                    <app-post-list
                      #DiscoverPostList
                      *ngIf="dashboardPosts"
                      [postList]="dashboardPosts"
                      [previewMode]="true"
                      [influencerGroupId]="influencerGroupId"
                      [gutter]="0"
                      [target]="target"
                    >
                    </app-post-list>
                  </div>
                </div>
                <div class="order-bar-container">
                  <influencer-home-order-bar
                    [discoverFilter]="currentFilterSearch"
                    (eventOrderList)="eventOrderList($event)"
                  ></influencer-home-order-bar>
                </div>
              </div>
            </div>
          </achoo-infinite-scroll>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-4 col-sm-12 dashboard-right-container">
      <div class="fixed-panel">
        <div id="recent_messages" class="d-flex flex-column recent-messages">
          <div class="d-flex flex-row">
            <div class="d-flex flex-auto recent-messages-header">
              <span class="d-none d-md-inline-block">{{ "dashboard.recent_messages" | translate }}</span>
              <span class="d-sm-inline-block d-md-none">{{ "dashboard.recent_notifications" | translate }}</span>
              <span class="counting">2</span>
            </div>
            <div class="d-flex flex-row align-items-center">
              <a class="recent-message-actions" (click)="editMessage()">{{'common.btn.edit' | translate}}</a>
            </div>
          </div>
          <div class="recent-messages-container">
            <recent-messages [messages]="recentMessages" [editable]="editingMessages" (removeMessage)="onConfirmRemoveMessage($event)"></recent-messages>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<message-popup #confirmRemoveMessageDialog class="remove-message-confirmation">
  <div class="remove-message-confirmation">
    <div class="modal-header">
      <h5 class="modal-title normal-popup-title d-none d-md-block">{{'dashboard.remove_message.title' | translate}}</h5>
      <a class="close" data-dismiss="modal" (click)="closeConfirmRemoveMessage()" aria-label="Close">
        <img src="/assets/images/Add_Icon.svg" class="icon-close-popup">
      </a>
    </div>
    <div class="modal-body">
      <div class="d-flex flex-column flex-auto">
        <span>{{'dashboard.remove_message.message' | translate: {sender: messageToRemove?.sender} }}</span>
      </div>
    </div>
    <div class="modal-footer justify-content-start align-items-center d-none d-md-block">
      <button (click)="oncConfirmRemoveMessage()" type="button" class="btn accept-button">{{'dashboard.remove_message.btn_confirm' | translate}}</button>
      <button type="button" (click)="closeConfirmRemoveMessage()" class="btn cancel-button" data-dismiss="modal">{{'dashboard.remove_message.btn_cancel' | translate}}</button>
    </div>
    <div class="modal-footer justify-content-end align-items-center d-flex d-md-none">
      <button type="button" class="button red" (click)="closeConfirmRemoveMessage()">{{'dashboard.remove_message.btn_remove' | translate}}</button>
    </div>
  </div>
</message-popup>


// WEBPACK FOOTER //
// ./src/app/main/influencer-home/influencer-home.component.html